
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M47.961 6.823a.99.99 0 00-.81-.22L30.324 9.442 13.496 6.604a.99.99 0 00-1.16.976v41.186c0 .488.35.896.83.986l16.998 2.857c.06.01.11.01.17.01.06 0 .11 0 .17-.01L47.5 49.752c.48-.08.83-.498.83-.986V7.58a1.1 1.1 0 00-.37-.757zM14.316 8.754l14.998 2.529v39.166L14.316 47.92V8.754zM46.311 47.93L31.314 50.46V11.283L46.31 8.754V47.93z"}}),_c('path',{attrs:{"d":"M24.924 14.12l-6.439-1.095a.99.99 0 00-1.16.976v5.874c0 .488.35.896.83.985l6.44 1.096c.06.01.11.01.17.01.23 0 .46-.08.65-.24.22-.189.35-.467.35-.756v-5.874a1.004 1.004 0 00-.84-.976zm-1.17 5.675l-4.439-.747v-3.852l4.44.756v3.843zM24.924 35.545l-6.439-1.095a.996.996 0 00-1.15.816.993.993 0 00.82 1.145l6.44 1.095c.06.01.11.01.17.01.48 0 .9-.338.98-.826a1 1 0 00-.82-1.145zM24.924 26.376l-6.439-1.095a.996.996 0 00-1.15.816.993.993 0 00.82 1.145l6.44 1.095c.06.01.11.01.17.01.48 0 .9-.338.98-.826a1.005 1.005 0 00-.82-1.145zM24.924 44.714l-6.439-1.095a.996.996 0 00-1.15.817.993.993 0 00.82 1.145l6.44 1.095c.06.01.11.01.17.01.48 0 .9-.339.98-.827a1 1 0 00-.82-1.145zM35.873 37.526c.06 0 .11 0 .17-.01l6.439-1.095a1 1 0 00.82-1.145 1.003 1.003 0 00-1.15-.816l-6.44 1.095a1 1 0 00-.82 1.145c.08.478.5.826.98.826zM35.873 28.357c.06 0 .11 0 .17-.01l6.439-1.095a1 1 0 00.82-1.145 1.003 1.003 0 00-1.15-.816l-6.44 1.095a1 1 0 00-.82 1.145c.08.488.5.826.98.826zM42.142 43.62l-6.439 1.094a1 1 0 00-.82 1.145c.08.488.51.827.98.827.06 0 .11 0 .17-.01l6.439-1.096a1 1 0 00.82-1.144 1.003 1.003 0 00-1.15-.817z"}})])
          )
        }
      }
    